"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var KushkiGateway_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.KushkiGateway = void 0;
/**
 * Kushki Gateway File
 */
/* tslint:disable: no-unnecessary-callback-wrapper */
const axios_1 = require("axios");
const AurusError_1 = require("./../../lib/generic/AurusError");
const EnvironmentEnum_1 = require("./../../lib/infrastructure/EnvironmentEnum");
const PathEnum_1 = require("./../../lib/infrastructure/PathEnum");
const inversify_1 = require("inversify");
require("reflect-metadata");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const UtilsService_1 = require("./../../lib/service/UtilsService");
const KushkiInfo_1 = require("./../../lib/KushkiInfo");
/**
 * Kushki Gateway Implementation
 */
let KushkiGateway = KushkiGateway_1 = class KushkiGateway {
    constructor() {
        this._publicHeader = "Public-Merchant-Id";
        this._contentHeader = "Content-Type";
        this._contentJSON = "application/json";
        this._kushkiInfoHeader = "X-Amz-Meta-Kushki-Info";
        this._uatUrl = "";
        this._prodUrl = "";
        this._kshAuthorization = "KSH-Authorization";
    }
    static _aurusError(data) {
        return data.hasOwnProperty("response_code");
    }
    request(body, headers, path, testEnv, regional) {
        return rxjs_1.of(this._assignChannel(regional, path)).pipe(operators_1.switchMap(() => axios_1.default.post(`${testEnv ? this._uatUrl : this._prodUrl}`, body, {
            headers: Object.assign(Object.assign({}, headers), { [this._contentHeader]: this._contentJSON }),
        })), operators_1.map((response) => response.data), operators_1.catchError((err) => {
            if (KushkiGateway_1._aurusError(UtilsService_1.UtilsService.sGet(err, "response.data", {})))
                throw new AurusError_1.AurusError(UtilsService_1.UtilsService.sGet(err, "response.data.response_code"), UtilsService_1.UtilsService.sGet(err, "response.data.response_text"));
            return rxjs_1.throwError(err);
        }));
    }
    requestGet(path, testEnv, regional, mid) {
        return rxjs_1.of(this._assignChannel(regional, path)).pipe(operators_1.switchMap(() => axios_1.default.get(`${testEnv ? this._uatUrl : this._prodUrl}`, {
            headers: {
                [this._publicHeader]: mid,
                [this._contentHeader]: this._contentJSON,
            },
        })), operators_1.map((response) => response.data), operators_1.catchError((err) => rxjs_1.throwError(err)));
    }
    requestDelete(path, testEnv, regional, mid, authorization) {
        return rxjs_1.of(this._assignChannel(regional, path)).pipe(operators_1.switchMap(() => axios_1.default.delete(`${testEnv ? this._uatUrl : this._prodUrl}`, {
            headers: {
                [this._contentHeader]: this._contentJSON,
                [this._kshAuthorization]: authorization,
                [this._publicHeader]: mid,
            },
        })), operators_1.map((response) => response.data), operators_1.catchError((err) => rxjs_1.throwError(err)));
    }
    requestBrandsByMerchant(mid, testEnv, regional) {
        return this.requestGet(`${PathEnum_1.PathEnum.brands_by_merchant}`, testEnv, regional, mid);
    }
    requestBrandsLogosByMerchant(mid, testEnv, regional) {
        return this.requestGet(`${PathEnum_1.PathEnum.brands_logos_by_merchant}`, testEnv, regional, mid);
    }
    requestToken(body, mid, testEnv, regional, authorization) {
        return rxjs_1.of(1).pipe(operators_1.concatMap(() => rxjs_1.iif(() => authorization === undefined, this.request(body, {
            [this._publicHeader]: mid,
            [this._kushkiInfoHeader]: KushkiInfo_1.KInfo.sKushkiInfo,
        }, PathEnum_1.PathEnum.card_tokens, testEnv, regional), this.request(body, {
            [this._kshAuthorization]: authorization,
            [this._publicHeader]: mid,
            [this._kushkiInfoHeader]: KushkiInfo_1.KInfo.sKushkiInfo,
        }, PathEnum_1.PathEnum.card_tokens, testEnv, regional))));
    }
    requestDeviceToken(body, mid, testEnv, regional) {
        return rxjs_1.of(1).pipe(operators_1.concatMap(() => this.request(body, Object.assign(Object.assign({}, this._buildHeader(mid)), { [this._kushkiInfoHeader]: KushkiInfo_1.KInfo.sKushkiInfo }), `${PathEnum_1.PathEnum.card_token_charge}${body.subscriptionId}/tokens`, testEnv, regional)));
    }
    requestSubscriptionToken(body, mid, testEnv, regional, authorization) {
        return rxjs_1.of(1).pipe(operators_1.concatMap(() => rxjs_1.iif(() => authorization === undefined, this.request(body, {
            [this._publicHeader]: mid,
            [this._kushkiInfoHeader]: KushkiInfo_1.KInfo.sKushkiInfo,
        }, PathEnum_1.PathEnum.card_subscription_tokens, testEnv, regional), this.request(body, {
            [this._kshAuthorization]: authorization,
            [this._publicHeader]: mid,
            [this._kushkiInfoHeader]: KushkiInfo_1.KInfo.sKushkiInfo,
        }, PathEnum_1.PathEnum.card_subscription_tokens, testEnv, regional))), operators_1.map((response) => response));
    }
    requestTransferToken(body, mid, testEnv, regional) {
        return rxjs_1.of(1).pipe(operators_1.concatMap(() => this.request(body, Object.assign(Object.assign({}, this._buildHeader(mid)), { [this._kushkiInfoHeader]: KushkiInfo_1.KInfo.sKushkiInfo }), PathEnum_1.PathEnum.transfer_tokens, testEnv, regional)));
    }
    requestMerchantSettings(mid, testEnv, regional) {
        return rxjs_1.of(1).pipe(operators_1.concatMap(() => this.requestGet(`${PathEnum_1.PathEnum.merchant_settings}settings`, testEnv, regional, mid)), operators_1.map((response) => response));
    }
    requestPseBankList(mid, testEnv, regional) {
        return rxjs_1.of(1).pipe(operators_1.concatMap(() => this.requestGet(PathEnum_1.PathEnum.bank_list, testEnv, regional, mid)), operators_1.map((response) => response));
    }
    requestDeferredConditions(mid, bin, testEnv, regional) {
        return rxjs_1.of(1).pipe(operators_1.concatMap(() => this.requestGet(`${PathEnum_1.PathEnum.deferred_options}${bin}`, testEnv, regional, mid)), operators_1.map((response) => response));
    }
    requestBinInfo(mid, bin, testEnv, regional) {
        return rxjs_1.of(1).pipe(operators_1.concatMap(() => this.requestGet(`${PathEnum_1.PathEnum.bin_info}${bin}`, testEnv, regional, mid)), operators_1.map((response) => response));
    }
    requestCashToken(body, mid, testEnv, regional) {
        return rxjs_1.of(1).pipe(operators_1.concatMap(() => this.request(body, Object.assign(Object.assign({}, this._buildHeader(mid)), { [this._kushkiInfoHeader]: KushkiInfo_1.KInfo.sKushkiInfo }), PathEnum_1.PathEnum.cash_tokens, testEnv, regional)), operators_1.map((response) => response));
    }
    checkStatus(mid, testEnv, regional) {
        return rxjs_1.of(1).pipe(operators_1.concatMap(() => this.requestGet(`${PathEnum_1.PathEnum.gateway_status}`, testEnv, regional, mid)), operators_1.map((response) => response));
    }
    requestSecureServiceValidation(mid, request, isTest, regional) {
        return rxjs_1.of(1).pipe(operators_1.concatMap(() => this.request(request, this._buildHeader(mid), `${PathEnum_1.PathEnum.secure_validation}`, isTest, regional)));
    }
    requestCardAsyncToken(body, mid, testEnv, regional) {
        return rxjs_1.of(1).pipe(operators_1.concatMap(() => this.request(body, Object.assign(Object.assign({}, this._buildHeader(mid)), { [this._kushkiInfoHeader]: KushkiInfo_1.KInfo.sKushkiInfo }), PathEnum_1.PathEnum.card_async_tokens, testEnv, regional)));
    }
    requestSubscriptionCardAsyncToken(body, mid, testEnv, regional) {
        return rxjs_1.of(1).pipe(operators_1.concatMap(() => this.request(body, Object.assign(Object.assign({}, this._buildHeader(mid)), { [this._kushkiInfoHeader]: KushkiInfo_1.KInfo.sKushkiInfo }), PathEnum_1.PathEnum.subscription_card_async_tokens, testEnv, regional)));
    }
    multiMerchantInfo(request, mid, isTest, regional) {
        return rxjs_1.of(1).pipe(operators_1.concatMap(() => this.request(request, this._buildHeader(mid), `${PathEnum_1.PathEnum.multi_merchant_commission}`, isTest, regional)));
    }
    requestPayoutsCashToken(body, mid, testEnv, regional) {
        return rxjs_1.of(1).pipe(operators_1.concatMap(() => this.request(body, Object.assign(Object.assign({}, this._buildHeader(mid)), { [this._kushkiInfoHeader]: KushkiInfo_1.KInfo.sKushkiInfo }), PathEnum_1.PathEnum.payouts_cash_tokens, testEnv, regional)), operators_1.map((response) => response));
    }
    requestPayoutsTransferToken(body, mid, testEnv, regional) {
        return rxjs_1.of(1).pipe(operators_1.concatMap(() => this.request(body, Object.assign(Object.assign({}, this._buildHeader(mid)), { [this._kushkiInfoHeader]: KushkiInfo_1.KInfo.sKushkiInfo }), PathEnum_1.PathEnum.payouts_transfer_tokens, testEnv, regional)), operators_1.map((response) => response));
    }
    getCommissionConfiguration(request, mid, isTest, regional) {
        return rxjs_1.of(1).pipe(operators_1.concatMap(() => this.request(request, this._buildHeader(mid), `${PathEnum_1.PathEnum.commission_configuration}`, isTest, regional)));
    }
    requestTokenTransferSubscription(body, mid, testEnv, regional) {
        return rxjs_1.of(1).pipe(operators_1.concatMap(() => this.request(body, Object.assign(Object.assign({}, this._buildHeader(mid)), { [this._kushkiInfoHeader]: KushkiInfo_1.KInfo.sKushkiInfo }), PathEnum_1.PathEnum.transfer_subscription_tokens, testEnv, regional)));
    }
    requestBankList(mid, testEnv, regional) {
        return rxjs_1.of(1).pipe(operators_1.mergeMap(() => this.requestGet(PathEnum_1.PathEnum.bank_list_transfer_subscription, testEnv, regional, mid)), operators_1.map((response) => response));
    }
    requestPayoutsTransferBankList(mid, testEnv, regional) {
        return rxjs_1.of(1).pipe(operators_1.mergeMap(() => this.requestGet(PathEnum_1.PathEnum.bank_list_payouts_transfer, testEnv, regional, mid)), operators_1.map((response) => response));
    }
    requestMobileProcessorToken(body, publicCredential, testEnv, regional) {
        return rxjs_1.of(1).pipe(operators_1.switchMap(() => this.request(body, this._buildHeader(publicCredential), PathEnum_1.PathEnum.mobile_processor_token, testEnv, regional)), operators_1.map((response) => response));
    }
    chargeMobileProcessor(body, publicCredential, testEnv, regional) {
        return rxjs_1.of(1).pipe(operators_1.switchMap(() => this.request(body, this._buildHeader(publicCredential), PathEnum_1.PathEnum.mobile_processor_charge, testEnv, regional)), operators_1.map((response) => response));
    }
    deletePaymentMethod(body, testEnv, regional, mid, authorization) {
        return rxjs_1.of(1).pipe(operators_1.switchMap(() => this.requestDelete(`${PathEnum_1.PathEnum.kpay_delete_payment_method}/${body.walletId}`, testEnv, regional, mid, authorization)), operators_1.map((response) => !!response));
    }
    requestSavedPaymentMethods(body, testEnv, regional, mid) {
        return rxjs_1.of(1).pipe(operators_1.map(() => {
            const { email, kind } = body;
            const kind_path = kind !== undefined ? `?kind=${kind}` : "";
            return `${PathEnum_1.PathEnum.kpay_get_saved_payment_methods}/${email}${kind_path}`;
        }), operators_1.concatMap((path) => this.requestGet(path, testEnv, regional, mid)), operators_1.map((response) => response));
    }
    cybersourceJwt(mid, testEnv, regional, subscriptionId) {
        return rxjs_1.of(1).pipe(operators_1.concatMap(() => this.requestGet(subscriptionId
            ? `${PathEnum_1.PathEnum.cybersource_jwt}?subscriptionId=${subscriptionId}`
            : PathEnum_1.PathEnum.cybersource_jwt, testEnv, regional, mid)), operators_1.map((response) => response));
    }
    getUserId(subscriptionId, mid, testEnv, regional) {
        return rxjs_1.of(1).pipe(operators_1.map(() => `${PathEnum_1.PathEnum.get_user_id}${subscriptionId}/user`), operators_1.concatMap((path) => this.request({}, {
            [this._publicHeader]: mid,
            [this._contentHeader]: this._contentJSON,
        }, path, testEnv, regional)), operators_1.map((response) => ({
            userId: response.userId,
        })));
    }
    _assignChannel(regional, path) {
        if (!regional) {
            this._uatUrl = `${EnvironmentEnum_1.EnvironmentEnum.uat}${path}`;
            this._prodUrl = `${EnvironmentEnum_1.EnvironmentEnum.prod}${path}`;
        }
        else {
            this._uatUrl = `${EnvironmentEnum_1.EnvironmentEnum.regionalUat}${path}`;
            this._prodUrl = `${EnvironmentEnum_1.EnvironmentEnum.regionalProd}${path}`;
        }
        return true;
    }
    _buildHeader(mid) {
        return {
            [this._publicHeader]: mid,
        };
    }
};
KushkiGateway = KushkiGateway_1 = __decorate([
    inversify_1.injectable()
], KushkiGateway);
exports.KushkiGateway = KushkiGateway;
